import React from "react";
import { createTrackingUtils } from "../";
import useUserAgent from "../../../hooks/useUserAgent";
import { UIRebookFLow, UITripRebookOption } from "@flights/types";

const trackRebookFlowExperiment = createTrackingUtils({
  defaultStage: 1,
  name: "flights_web_pb_rebook_self_serve_m1",
  stages: {
    AFFECTED_USERS: 1,
    PRICE_REVIEW_SELF_SERVE_AVAILABLE: 2,
    PRICE_REVIEW_SELF_SERVE_AVAILABLE_DESKTOP: 3,
    PRICE_REVIEW_SELF_SERVE_AVAILABLE_MDOT: 4
  },
  goals: {
    CLICK_CS_CHANNEL: 1, // User clicks on "Book via chat" in base or "Select" in variant,
    CLICK_COST_BREAKDOWN: 2,
    CLICK_CONFIRM_PAY: 3,
    CLICK_BACK_ON_PAY: 4
  },
  goalsWithValue: []
});

export const useTrackRebookFlowExperiment = (
  rebookFlow?: UIRebookFLow | null,
  tripRebookOption?: UITripRebookOption
) => {
  const { isMobile } = useUserAgent();
  const eligibleForSelfServe =
    rebookFlow === "CHANGE_TRIP_YOURSELF" &&
    // rebookingOfferReference is used to create a rebooking cart and indicates that booking could be rebooked by user
    // without reaching to help center via chat.
    !!tripRebookOption?.rebookingOfferReference;

  React.useEffect(() => {
    if (eligibleForSelfServe) {
      trackRebookFlowExperiment.stages.PRICE_REVIEW_SELF_SERVE_AVAILABLE();

      if (isMobile) {
        trackRebookFlowExperiment.stages.PRICE_REVIEW_SELF_SERVE_AVAILABLE_MDOT();
      } else {
        trackRebookFlowExperiment.stages.PRICE_REVIEW_SELF_SERVE_AVAILABLE_DESKTOP();
      }
    }
  }, [isMobile, eligibleForSelfServe]);

  return {
    isRebookFlowExperimentInVariant: eligibleForSelfServe && trackRebookFlowExperiment.trackWithDefaultStage() === 1
  };
};
